import {Component, EventEmitter, Input, OnInit, Output} from "@angular/core";
import {Store} from "@ngrx/store";
import {AppState} from "../../../store/state/app.state";
import {Order, StandardName} from "../../../store/state/order.state";
import {OrderActions} from "../../../store/actions/order.actions";
import {Actions, ofType} from "@ngrx/effects";
import {map, take} from "rxjs/operators";
import {ActivatedRoute} from "@angular/router";
import {Observable} from "rxjs";
import {StandardConfiguration} from "../../resolvers/standard-configurations-resolver.service";

@Component({
    selector: 'standard-selection',
    templateUrl: './standard-selection.template.html',
    styleUrls: ['./standard-selection.style.scss'],
    standalone: false
})
export class StandardSelectionComponent implements OnInit {

	@Input() order: Order;
	@Input() showValidationMessage: boolean;
	@Input() title: string;
	@Input() subtitle: string;
	@Output() selectionChanged: EventEmitter<{ standard: string, selected: boolean }> = new EventEmitter();
	standardSelectionDisabled: boolean = false;
	standardConfigurations: Observable<StandardConfiguration[]>;

	constructor(private store: Store<AppState>, private actions$: Actions, private route: ActivatedRoute) {
	}

	ngOnInit(): void {
		this.standardConfigurations = this.route.data.pipe(map(data => data['standardConfigurations']));
		this.actions$.pipe(ofType(OrderActions.REQUEST_ORDER)).subscribe(() => {
			this.standardSelectionDisabled = true;
		});
	}

	isStandardSelected(standardName: StandardName | string): boolean {
		return this.order.products.some(product => product.standard.name == standardName);
	}

	selectStandard(standard: StandardName, selected: boolean) {
		this.selectionChanged.emit({standard, selected});
		this.store.dispatch(OrderActions.SELECT_STANDARD({standard, selected}));
		if (!selected) {
			this.unSelectDependentStandards(standard);
		}
	}

	private unSelectDependentStandards(chosenStandard: StandardName) {
		this.standardConfigurations.pipe(take(1)).subscribe(configurations => {
			configurations.filter(c => c.availableWith.includes(chosenStandard)).forEach(c => {
				this.selectionChanged.emit({standard: c.standard, selected: false});
				this.store.dispatch(OrderActions.SELECT_STANDARD({standard: c.standard, selected: false}));
			});
		});
	}

	possibleStandards(): Observable<StandardName[]> {
		return this.standardConfigurations.pipe(
			map(configurations => configurations.map(conf => conf.standard))
		);
	}

	dependentStandardNotChosen(standard: StandardName): Observable<boolean> {
		return this.standardConfigurations.pipe(
			map(configurations =>
				configurations.filter(conf => conf.standard == standard)
					.map(conf => conf.availableWith.length != 0 && conf.availableWith.some(s => !this.isStandardSelected(s)))[0]
			)
		);
	}

	disableTooltip(standard: StandardName): boolean {
		return (standard != StandardName.ISO_27701) || this.isStandardSelected(StandardName.ISO_27001);
	}
}
